import React from "react";
import Input from "Components/UI/Input";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
const boolStatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const AuditLogModal = ({ mode = "I", show = false, handleClose, data }) => {
  return (
    <Modal show={show} onHide={handleClose} animation={true} centered size="lg">
      <Modal.Header
        className="modal-header border-0 custom-modal-header"
        style={{ justifyContent: "space-between" }}
      >
        <div className="page-title">
          <h4>Audit Log Details</h4>
        </div>
        <button type="button" className="close" onClick={handleClose}>
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div
          className=""
          style={{
            wordWrap: "break-word",
          }}
        >
          {data?.newDescription}
        </div>
      </Modal.Body>
    </Modal>
  );
};

AuditLogModal.propTypes = {
  mode: PropTypes.oneOf(["I", "E"]),
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  data: PropTypes.any,
};

export default AuditLogModal;
